import { isChrome, isFirefox, isSafari } from './browser-detect';

export function isEmbeddedDocument(): boolean {
  return window.top !== window.self;
}

export const isTabActive = (): boolean =>
  document.visibilityState === 'visible';

export const isHighDPI = (): boolean => window.devicePixelRatio > 1;

export const supportsDynamicFavicon = (): boolean => isChrome() || isFirefox();

export const supportsFancyPeel = (): boolean =>
  isChrome() || isFirefox() || isSafari();
